import {
    USER_SIGNOUT_SUCCESS,
    PUT_USER,
    SET_USER_SEARCHPARAMS,
    PUT_SYSTEM_SETTINGS,
    PUT_ACCESS_TOKEN,
} from '../actionTypes';
import store from 'store';

const INIT_STATE = {
    accessToken: store.get('access_token') || null,
    authUser: null,
    systemSettings: null,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case USER_SIGNOUT_SUCCESS: {
            store.clearAll();
            return {
                ...state,
                accessToken: null,
                authUser: null,
            };
        }

        case PUT_ACCESS_TOKEN: {
            store.set('access_token', action.payload);
            return {
                ...state,
                accessToken: action.payload,
            };
        }

        case PUT_USER: {
            return {
                ...state,
                authUser: action.payload,
            };
        }

        case SET_USER_SEARCHPARAMS: {
            return {
                ...state,
                memberSearchParams: action.payload,
            };
        }

        case PUT_SYSTEM_SETTINGS: {
            return {
                ...state,
                systemSettings: action.payload,
            };
        }

        default:
            return state;
    }
};
